import { ElementRef, inject, Injectable } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subject } from 'rxjs';
import { NICmsContentComponent } from '../content';
@Injectable()
export abstract class ICmsCoreIntegrationAbstractService<T> {
    /**
     * List of all icms directives being active
     */
    readonly entries = new Set<T>();

    /**
     * Directive added event
     */
    readonly entryAdd$ = new Subject<T>();

    /**
     * Directive removed event
     */
    readonly entryRemove$ = new Subject<T>();

    /**
     * Dependencies
     */
    private timeoutService = inject(TimeoutService);

    /**
     * Registers initiated cms entry
     */
    registerEntry(entry: T) {
        this.timeoutService.setTimeout(() => {
            this.entries.add(entry);
            this.entryAdd$.next(entry);
        });
    }

    /**
     * Unregisters cms entry from the set
     */
    unregisterEntry(entry: T) {
        this.entries.delete(entry);
        this.entryRemove$.next(entry);
    }

    getInstanceElement(entry: NICmsContentComponent.IComponent): HTMLElement {
        const node = entry.node;
        if (node) {
            if (node instanceof ElementRef) {
                return node.nativeElement;
            }
            return node;
        }
        return entry.injector.get<ElementRef>(ElementRef).nativeElement;
    }
}
